var map = {
	"./logo-short.png": 56,
	"./logo.png": 5689,
	"./logoCZ.png": 8030,
	"./logoES.png": 5129,
	"./logoIT.png": 5909,
	"./logoMX.png": 6898,
	"./logoPL.png": 2565,
	"./logoRO.png": 6920,
	"./logoRU.png": 4530,
	"./logoTR.png": 1231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6819;